import React from 'react';

const StudentTcDetails = () => {
  return <div>Student Tc Details is Available in React</div>;
};

export default StudentTcDetails;
